import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router';

import LangSwitch from '../../../../shared/lang/switch';
import InputField from '../../../../shared/form-elements/input';
import SelectField from '../../../../shared/form-elements/select/field';
import UploadField from '../../../../shared/form-elements/upload';

const getTranslationFieldName = lang => lang !== 'en' ? `translations.${lang}.` : '';

const translationSwitcher = (lang, intl) => (
	<div>
		<div className='ui-form__element'>
			<Field
				name={`${getTranslationFieldName(lang)}title`}
				placeholder={intl('Title')}
				component={InputField}
			/>
		</div>
	</div>
);

const Main = props => {
	return (
		<div className='goods-form-wrap'>
			<div className='goods-form-wrap__langs'>
				<LangSwitch
					langs={props.mainTabLangs}
					onChangeLang={props.mainFormChangeLanguage}
				/>
			</div>
			<form
				onSubmit={props.handleSubmit(props.mainFormSubmit)}
				className='ui-form goods-form__main clearfix'
			>
				<div className='goods-form__main-fields'>
					{(translationSwitcher(props.currentLanguage, props.intl))}
					<div className='selectors-wrapper'>
						<div className='ui-form__element status'>
							<Field
								name='country'
								placeholder={props.intl('Country')}
								component={SelectField}
								searchable={true}
								clearable={true}
								multi={false}
								options={props.locationsLookup}
							/>
						</div>
						<div className='ui-form__element category'>
							<Field
								name="offer_category"
								placeholder={ props.intl('Offer category') }
								component={SelectField}
								searchable={false}
								options={props.offerCategoriesOptions} />
						</div>
					</div>
					<div className='ui-form__element category'>
						<Field
							name="start_period"
							placeholder={ props.intl('Period') }
							component={SelectField}
							searchable={false}
							options={props.startPeriodOptions} />
					</div>
					<div className='ui-form__element category'>
						<Field
							name="leads_required"
							placeholder={ props.intl('Leads required') }
							component={InputField}
						/>
					</div>
				</div>
				<div className='goods-form__main-meta'>
					<div className='ui-form__element'>
						<Field
							name='image'
							component={UploadField}
							placeholder={props.intl('Upload')}
							preparationFile={props.preparationFile}
						/>
					</div>
				</div>
				<div className='goods-form__footer'>
					<div className='ui-form__element buttons-wrap'>
						{props.can('edit') && (
							<button className='ui-btn ui-btn-primary'>
								{props.intl(props.data.id ? 'Update' : 'Save')}
							</button>
						)}
						<Link
							to='/missions'
							className='ui-btn ui-btn-cancel'
						>{props.intl('Cancel')}</Link>
					</div>
				</div>
			</form>
		</div>
	);
};

Main.propTypes = {
	intl: PropTypes.func
};

export default reduxForm({
	form: 'achievementsMainForm'
})(Main);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/missions/components/forms/general/main.js